<template>
<div>
  <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
    <div class="title-h3">스캔 방식 선택</div>
    <div>
      <el-button class="mr-r4" @click="clickPreStep" :disabled="!isLoaded">전단계</el-button>
      <el-button type="primary" @click="clickNextStep" :disabled="!isLoaded">다음단계</el-button>
    </div>
  </el-row>
  <el-table-wrapper :data="scanMethodTableData" :columns="scanMethodTableColumn" :column-default="columnDefault" ref="scanMethodTable" :pagination="false" style="width:100%;" :show-search-tool="false" :show-custom-header="true">
    <template slot-scope="scope" slot="credential-slot">
        <el-select v-model="scope.row.credentialId" @change="changeCredentialId(scope.row)">
          <el-option v-for="item in credentialList" :key="item.credentialId" :label="item.credentialName" :value="item.credentialId"></el-option>
        </el-select>
      </template>
  </el-table-wrapper>
</div>
</template>

<script>
import { orderBy, cloneDeep, isNil, isEqual } from 'lodash';
import { columnDefault } from '@/constants/table';
import DeviceRegistrationNmsAPI from '@/api/settings/common/device-registration-nms';

export default {
  name: 'WScanMethodSetting',
  props: {
    checkedIpSearchRows: Array,
  },
  data() {
    return {
      isLoaded: false,
      scanMethodTableData: [],
      columnDefault,
      scanMethodTableColumn: [
        {
          prop: 'scanType',
          label: 'IP검색방법',
          headerAlign: 'center',
          formatter: this.scanTypeFormatter,
        },
        {
          prop: 'startAddress',
          label: '시작IP',
          headerAlign: 'center',
        },
        {
          prop: 'endAddress',
          label: '종료IP',
          headerAlign: 'center',
        },
        {
          label: '예외구간',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'exceptStartAddress',
              label: '예외시작IP',
              headerAlign: 'center',
            },
            {
              prop: 'exceptEndAddress',
              label: '예외종료IP',
              headerAlign: 'center',
            },
          ],
        },
        {
          prop: 'credentialName',
          label: '스캔방식 선택',
          headerAlign: 'center',
          scopedSlot: 'credential-slot',
        },
        {
          prop: 'credentialDesc',
          label: '스캔방식 설명',
          headerAlign: 'center',
        },
      ],
      credentialList: [],
    };
  },
  mounted() {
    DeviceRegistrationNmsAPI.getModelingMethodList({
      credentialMethodId: 'SCAN',
    }).then((response) => {
      if (!isNil(response.data.data)) {
        this.credentialList = response.data.data;
      }
      this.loadData();
    });
  },
  methods: {
    loadData() {
      this.isLoaded = false;
      const scanMethodTableData = orderBy(cloneDeep(this.checkedIpSearchRows), 'scanId', 'asc');
      if (this.credentialList.length > 0) {
        const firstCredential = cloneDeep(this.credentialList)[0];
        scanMethodTableData.forEach((object) => {
          const credentialId = object.credentialId;
          if (isNil(credentialId)) {
            object.credentialId = firstCredential.credentialId;
            object.credentialName = firstCredential.credentialName;
            object.credentialDesc = firstCredential.credentialDesc;
          }
        });
      }
      this.scanMethodTableData = scanMethodTableData;
      this.isLoaded = true;
    },
    changeCredentialId(row) {
      const credentialId = row.credentialId;
      const credentialObject = this.credentialList.find((object) => isEqual(credentialId, object.credentialId));
      Object.assign(row, credentialObject);
    },
    clickNextStep() {
      this.$emit('click-next-step', this.scanMethodTableData, 'checkedIpSearchRows');
    },
    clickPreStep() {
      this.$emit('click-pre-step', this.scanMethodTableData, 'checkedIpSearchRows');
    },
    scanTypeFormatter(row, column, value) {
      let result = null;
      if (!isNil(value)) {
        if (isEqual(value, 'SPOT')) {
          result = '단일 IP';
        } else if (isEqual(value, 'RANGE')) {
          result = 'IP 구간';
        } else {
          result = '서브넷마스크';
        }
      }
      return result;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/components/ScanMethodSetting.vue